"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUniqueId = exports.default = void 0;
var _react = require("react");
var _nanoid = require("./nanoid");
var useUniqueId = exports.useUniqueId = function useUniqueId() {
  var id = (0, _react.useRef)((0, _nanoid.generate)());
  return id.current;
};
var _default = exports.default = useUniqueId;